import { Controller } from '@hotwired/stimulus';
import {
  CONSENT_STUDIO_UPDATED_EVENT,
  syncConsentStudioUpdatedEvent,
} from '../application/common/consent_studio_sync';

const PROVIDERS = {
  consent_studio: {
    event: CONSENT_STUDIO_UPDATED_EVENT,
  },
};

export default class extends Controller {
  static values = { provider: String };

  connect() {
    this.config = PROVIDERS[this.providerValue];
    if (!this.config) {
      return;
    }

    this.boundSync = syncConsentStudioUpdatedEvent;
    window.addEventListener(this.config.event, this.boundSync);
  }

  disconnect() {
    if (this.config) {
      window.removeEventListener(this.config.event, this.boundSync);
    }
  }
}
